import { useEffect } from 'react'
import { Map } from 'leaflet'
import { FiArrowLeft } from 'react-icons/fi'
import { TileLayer, ZoomControl, useMap } from 'react-leaflet'
import MarkerClusterGroup from 'react-leaflet-markercluster'
import { IProperty } from 'interfaces/property'
import { checkValidCoordinates, getValidArray } from 'utils/common'
import Marker from '../Marker'
import { BackButton, BackButtonText, createClusterCustomIcon } from './mapbox.styles'

interface IMapboxProps {
  houseList: IProperty[]
  showMap: boolean
  setMapModule: (map: Map) => void
  setShowMap: (status: boolean) => void
  changePosition: (lat: number, lng: number) => void
}

const Mapbox = (props: IMapboxProps) => {
  const { houseList, showMap, setMapModule, setShowMap, changePosition } = props
  const map: Map = useMap()

  function onBack(): void {
    setShowMap(false)
  }

  useEffect(() => {
    setMapModule(map)
    map.invalidateSize()
    map.attributionControl.setPrefix('Livehomeroom.com ©')
  }, [showMap])

  return (
    <>
      <TileLayer
        maxZoom={15}
        url={process.env.MAP_BOX_URL || 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png'}
        attribution='Map data &copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors, <a href="https://creativecommons.org/licenses/by-sa/2.0/">CC-BY-SA</a>, Imagery &copy; <a href="https://www.mapbox.com/">Mapbox</a>'
      />
      <BackButton onClick={onBack}>
        <FiArrowLeft color="#000" />
        <BackButtonText>Back to list</BackButtonText>
      </BackButton>
      <ZoomControl position="topright" />
      <MarkerClusterGroup
        iconCreateFunction={createClusterCustomIcon}
        showCoverageOnHover={false}
        singleMarkerMode={false}
        spiderfyOnMaxZoom={false}
        disableClusteringAtZoom={16}
      >
        {getValidArray(houseList).map((marker: IProperty) => {
          if (!checkValidCoordinates(marker?.fakeLat ?? marker.lat, marker.fakeLng ?? marker.lng)) {
            return null
          }
          return <Marker key={`marker-${marker.id}`} changePosition={changePosition} {...marker} />
        })}
      </MarkerClusterGroup>
    </>
  )
}

export default Mapbox
